import { useState } from 'react';
import { string, element, func } from 'prop-types';
import TrackingHelper from 'src/utils/trackingHelper';
import { StyledLink } from 'src/components/common/styledComponents/styledLink';

const CLICK_TIMEOUT = 300;

export const TrackedLink = props => {
  const [clickHandled, setClickHandled] = useState(false);

  const trackClick = () => {
    const label = typeof children === 'string' ? props.children : props.label;
    TrackingHelper.track('LINK_CLICKED', { to: props.href, label });
  };

  const handleClick = event => {
    if (clickHandled) return;

    const element = event.currentTarget;
    setClickHandled(true);
    event.preventDefault();
    event.stopPropagation();

    setTimeout(() => {
      element && element.click();
    }, CLICK_TIMEOUT);

    trackClick();
    if (props.onClick) {
      props.onClick();
    }
  };

  return <StyledLink {...props} onClick={handleClick} />;
};

TrackedLink.propTypes = {
  href: string,
  children: element,
  label: string,
  onClick: func,
};
